export default "__VITE_ASSET__2ad6bde8__"